var exports = {
  "ms": "ReviewThreadContainer__zrJcUC",
  "nK": "isReply__rtuCwO",
  "U5": "anchorable__CYZLsP",
  "Ku": "ReviewThreadWrapper__vspFQB",
  "cw": "ReviewThreadBox__cByjzb",
  "m3": "ReviewThreadInnerContainer__cag4y4",
  "ez": "ReplyWrapper__eFctcX",
  "oG": "SafeHTMLBox__N9Ecgv",
  "nE": "SafeHTMLBoxWrapped__qUULz2",
  "rw": "BodyHTMLContainer__vHY_bu",
};

module.exports = exports;
